import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
// import Swal from "sweetalert2";
import { Link, useLocation } from "react-router-dom";

interface NavbarProps {
  onInstructionClick: () => void;
  onLoginClick: () => void;
  onSettingsClick: () => void;
  onProjectsClick: () => void;
  onLogout: () => void;
  currentUsername: string | null;
  currentDisplayName: string | null;
  currentProjectName: string | null;
}

const Navbar: React.FC<NavbarProps> = ({
  onInstructionClick,
  onLoginClick,
  onSettingsClick,
  onProjectsClick,
  onLogout,
  currentUsername,
  currentDisplayName,
  currentProjectName,
}) => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isFullWidthPage =
    location.pathname === "/dashboard" ||
    location.pathname === "/" ||
    location.pathname === "/planning";

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark"
      style={{ backgroundColor: "#2196f3" }}
    >
      <div className={isFullWidthPage ? "container-fluid px-4" : "container"}>
        <a className="navbar-brand" href="/">
          <img
            src={process.env.PUBLIC_URL + "/ews_icon.png"}
            alt="EWS Logo"
            style={{ height: "40px", marginRight: "10px" }}
          />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsMenuOpen((open) => !open)}
          aria-controls="navbarNav"
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className={`navbar-collapse ${isMenuOpen ? "d-block" : "collapse"} d-lg-flex align-items-lg-center`}
          id="navbarNav"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className="nav-link text-white fw-bold" to="/about">
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-white fw-bold" to="/">
                Dashboard
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link text-white fw-bold"
                to="/planning"
                onClick={() => setIsMenuOpen(false)}
              >
                Planning
              </Link>
            </li>
            <li className="nav-item">
              <button
                className="nav-link text-white fw-bold btn btn-link"
                style={{ textDecoration: "none" }}
                onClick={() => {
                  setIsMenuOpen(false);
                  onSettingsClick();
                }}
              >
                Preferences
              </button>
            </li>
            {/*}
            <li className="nav-item">
              <button
                className="nav-link text-white fw-bold btn btn-link"
                style={{ textDecoration: "none" }}
                onClick={() => {
                  setIsMenuOpen(false);
                  onInstructionClick();
                }}
              >
                Instructions
              </button>
            </li>
            */}
          </ul>

          <Link
            className="nav-link text-white fw-bold ms-lg-auto me-lg-3 mt-2 mt-lg-0"
            to="/contact"
            onClick={() => setIsMenuOpen(false)}
          >
            Get in Touch
          </Link>

          {currentUsername ? (
            <Dropdown align="end" className="me-lg-3 mt-2 mt-lg-0">
              <Dropdown.Toggle
                className="btn btn-link text-white fw-bold"
                style={{ textDecoration: "none", border: "none", boxShadow: "none" }}
              >
                {currentDisplayName ?? currentUsername}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  as="button"
                  onClick={() => {
                    setIsMenuOpen(false);
                    onProjectsClick();
                  }}
                >
                  Projects
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  onClick={() => {
                    setIsMenuOpen(false);
                    onLogout();
                  }}
                >
                  Disconnect
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <button
              className="nav-link btn btn-link text-white fw-bold me-lg-3 mt-2 mt-lg-0 text-start"
              style={{ textDecoration: "none", border: "none", boxShadow: "none" }}
              onClick={() => {
                setIsMenuOpen(false);
                onLoginClick();
              }}
            >
              Login
            </button>
          )}

          {/*
          <button
            className="nav-link btn btn-link fw-bold d-flex align-items-center text-start mt-2 mt-lg-0"
            style={{
              color: "#f1c40f",
              textDecoration: "none",
            }}
            onClick={() => {
              setIsMenuOpen(false);
              Swal.fire({
                icon: "warning",
                title: "Avertissement",
                html: "⚠️ L'application en français est en cours de développement. Elle sera disponible bientôt !<br>Appuyez sur <strong>OK</strong> pour continuer la navigation",
                confirmButtonText: "<strong>OK</strong>",
              });
            }}
          >
            <i className="bi bi-globe me-1"></i> FR
          </button>
          */}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
